//  Name: course
import EventBus from '@/helpers/event-bus'
import '@/components/paypal-button'
import '@/components/new-price'

export default {
  data () {
    return {
      id: null,
      course: null
    }
  },
  methods: {
    getCourse () {
      // EventBus.$emit('waitMessage')
      const slug = this.$route.params.slug.split('-')
      this.id = slug[slug.length - 1]
      var vm = this
      vm.$http.get('courses/' + vm.id + '/')
      .then(function (response) {
        let data = response.body
        if (data.status === 'ok') {
          data.course.id = vm.id
          vm.$set(vm, 'course', data.course)
          EventBus.$emit('dismissMessage')
        } else {
          EventBus.$emit('errorMessage', data.message)
        }
      }, function (error) {
        console.error(error)
        EventBus.$emit('errorMessage', 'Ha ocurrido un problema de comunicación con el servidor')
      })
    },
    go () {
      window.location = this.course.short_description
      // for (var index in this.course.price) {
      //   if (this.course.price[index].number === 0) {
      //     this.$router.push({name: 'Felicidades', params: {courseId: this.id}})
      //   } else {
      //     window.localStorage.setItem('course_pay', JSON.stringify(this.course))
      //     this.$router.push({name: 'Pagar curso'})
      //   }
      // }
    }
  },
  mounted () {
    this.getCourse()
  }
}



// WEBPACK FOOTER //
// ./src/pages/course/script.js